module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "legal",
    class: {
      'open': _vm.footerOpen
    }
  }, [_c('div', {
    staticClass: "footer-trigger",
    on: {
      "click": _vm.triggerFooterExpand
    }
  }), _vm._v(" "), _vm._m(0, false, false)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-content"
  }, [_c('p', {
    staticClass: "copyright"
  }, [_vm._v("\n\t\t™ AND © TWENTIETH CENTURY FOX FILM CORPORATION. ALL RIGHTS RESERVED. PROPERTY OF FOX.\n\t\t")]), _vm._v(" "), _c('ul', {
    staticClass: "footer-menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "https://www.foxprivacy.com/us/terms_whatsnew.html",
      "target": "_blank"
    }
  }, [_vm._v("NEW TERMS AND CONDITIONS (WHAT’S CHANGED?)")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.foxprivacy.com/us/privacy.html",
      "target": "_blank"
    }
  }, [_vm._v("NEW PRIVACY POLICY")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.foxprivacy.com/us/privacy.html#section2",
      "target": "_blank"
    }
  }, [_vm._v("AD CHOICES")])])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-50ee8d0f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50ee8d0f","transformToRequire":{"video":["src","poster"],"source":"src","object":"data","iframe":"src","embed":"src","a":"href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Legal.vue
// module id = 406
// module chunks = 0